export const authQs = (user: string, apiKey: string) =>
  `?z=${user}&y=${apiKey}`;
